module.exports = __webpack_public_path__ + "static/img/2.d2bc34f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/2.png
// module id = u3Mr
// module chunks = 0